import React from 'react'
import PropTypes from 'prop-types'
import { Typography } from '@chilecompra/react-kit/components'
import {
  DialogContainer,
  DialogContent,
  DialogIcon,
  CloseDialogIcon,
  DialogText,
  Strong
} from './MaintenanceDialog.styles'

/**
 * The Maintenance Dialog's component.
 */
const MaintenanceDialog = props => {
  const handleCloseDialog = () => {
    props.close(true)
  }
  return (
    <DialogContainer>
      <DialogContent>
        <DialogIcon />
        <DialogText>
          <Typography align="left" color="black1" fontSize="14px" margin="16px 0" padding="0 24px 0 0" variant="body2">
            <Strong>Estimadas usuarias y usuarios:</Strong>
            <br />
            Les informamos que el próximo lunes 30 de junio de 2025, se realizará una mantención programada en la
            plataforma datos-abiertos.chilecompra.cl, entre las 14:00 y 17:00 horas.
            <br />
            Durante este periodo, el sitio podría no estar disponible o presentar intermitencias en su funcionamiento.
            <br />
            Lamentamos los inconvenientes que esto pueda ocasionar y agradecemos su comprensión.
            <br />
            <br />
            Atentamente
            <br />
            Dirección ChileCompra
          </Typography>
          <CloseDialogIcon onClick={handleCloseDialog} />
        </DialogText>
      </DialogContent>
    </DialogContainer>
  )
}

MaintenanceDialog.propTypes = {
  close: PropTypes.func.isRequired
}

export default MaintenanceDialog
